import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    justNow: { type: String, default: "just now" },
    minAgo: { type: String, default: "%{n} min ago" },
    hrAgo: { type: String, default: "%{n} hr ago" },
    daysAgo: { type: String, default: "%{n} days ago" },
  };

  connect() {
    this.update();
    this.interval = setInterval(() => this.update(), 60_000);
  }

  disconnect() {
    clearInterval(this.interval);
  }

  update() {
    const date = new Date(this.element.getAttribute("datetime"));
    if (!isNaN(date)) this.element.textContent = this.timeAgo(date);
  }

  timeAgo(date) {
    const s = Math.floor((Date.now() - date) / 1000);
    if (s < 60) return this.justNowValue;
    if (s < 3600) return this.minAgoValue.replace("%{n}", Math.floor(s / 60));
    if (s < 86400) return this.hrAgoValue.replace("%{n}", Math.floor(s / 3600));
    return this.daysAgoValue.replace("%{n}", Math.floor(s / 86400));
  }
}
